import { render, staticRenderFns } from "./Emissao.vue?vue&type=template&id=c268af6e"
import script from "./Emissao.vue?vue&type=script&lang=js"
export * from "./Emissao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports